import { baseApi } from "api/BaseApi";
import { Option } from "api/common/types/common.types";

import {
  ProductCCPayload,
  MaintenanceCCPayload,
  LabPayload,
  ProductCC,
  ProductCCOption,
  MaintenanceCC,
  MaintenanceCCOption,
  LabStub,
} from "./pcm.types";

const PCM_BASE_QUERY = "/pcm";

const pcmApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getPcmFormProducts: build.query<ProductCCOption[], ProductCCPayload>({
      query: (payload) => {
        return {
          url: `${PCM_BASE_QUERY}/get_cc_portal_products/`,
          params: payload,
        };
      },
      transformResponse: (response: ProductCC[]) =>
        response.map((product) => ({
          label: product.name,
          value: product,
          scheme: product.country,
        })),
    }),
    getPcmFormLabs: build.query<Option[], LabPayload>({
      query: (payload) => {
        return {
          url: `${PCM_BASE_QUERY}/get_cc_portal_labs/`,
          params: payload,
        };
      },
      transformResponse: (response: LabStub[]) =>
        response.map((lab) => ({
          label: lab.cctl_name,
          value: lab.cctl_id,
        })),
    }),
    getPcmFormMaintenances: build.query<
      MaintenanceCCOption[],
      MaintenanceCCPayload
    >({
      query: (payload) => {
        return {
          url: `${PCM_BASE_QUERY}/get_cc_portal_maintenances/`,
          params: payload,
        };
      },
      transformResponse: (response: MaintenanceCC[]) =>
        response.map((maintenance) => ({
          label: maintenance.name,
          value: maintenance,
        })),
    }),
  }),
});

export const {
  useGetPcmFormLabsQuery,
  useGetPcmFormMaintenancesQuery,
  useGetPcmFormProductsQuery,
} = pcmApi;
